/**
 * G-85 S4 — what is inside a box, in words: "3 items · 12 units", or "Empty".
 *
 * Written once because it was written twice. `ShopFloorBoxCard` and
 * `ShopFloorBoxList` each carried their own copy, and each pluralised by
 * hand — `itemCount === 1 ? "item" : "items"`. That is the same construction
 * S3 deleted from the bouquet stock panel, where it produced "стебельs":
 * English is the only language whose plural is a suffix on the singular, and
 * Russian and Ukrainian need three forms rather than two. The dictionary's
 * plural keys and `Intl.PluralRules` do the work now.
 *
 * Pure and in `utils/` because that is where this repo's testable frontend
 * logic goes — the Jest project has no jsx and cannot import a component.
 * `totalUnits` arrives from the API as a decimal string, so it is converted
 * here rather than at each call site.
 */
import { t } from "../i18n/t";

export function boxContentsSummary(
  itemCount: number,
  totalUnits: string | number,
): string {
  if (itemCount === 0) return t("box.empty");
  const units = Number(totalUnits);
  return [
    t("box.itemCount", { count: itemCount }),
    t("box.unitCount", { count: Number.isFinite(units) ? units : 0 }),
  ].join(" · ");
}
